module.exports = __webpack_public_path__ + "img/GI.940c0e9c.svg";